import { required } from 'react-admin';
import { Box } from 'shared/mui/Box';
import { SelectInput } from 'shared/react-admin/Inputs';
import { ReferenceInput } from 'shared/react-admin/ReferenceInputs';

export const CommissionsCreateLadderBase = () => {
  return (
    <Box display="flex" gap={3}>
      <ReferenceInput reference="commission_ladder_types" source="ladder.ladderType">
        <SelectInput
          fullWidth
          label="Тип лесенки"
          optionText="description"
          source="description"
          validate={required()}
          variant="outlined"
        />
      </ReferenceInput>
      <ReferenceInput reference="commission_ladder_period_types" source="ladder.periodType">
        <SelectInput
          fullWidth
          label="Период оборота"
          optionText="description"
          source="description"
          validate={required()}
          variant="outlined"
        />
      </ReferenceInput>
    </Box>
  );
};
